<template>
    <div>
        <!-- <pre>{{ permissions }}</pre> -->
        <template v-if="action=='view'">
            <div class="table-settings mb-4" v-if="allData.length>0 || q!=''">
                <div class="row align-items-center justify-content-between">
                    <div class="col col-md-6 col-lg-3 col-xl-4">
                    </div>
                    <div class="col-4 col-md-2  pl-md-0 text-right">
                    </div>
                </div>
            </div>
            <div class="card border-light shadow-sm mb-4">
                <!-- <pre>{{ category_list }}</pre> -->
                <div style="position: absolute; margin-top: 120px; z-index: 1; width: max-content; left: 50%; transform: translate(-50%, 0%);" v-if="!permissions.find(e => e.permission_name == 'View Options')">
                    <span style="color: red;"><i class="mr-2 fa fa-eye-slash"></i>You dont have the viewing permission.</span>
                </div>
                <div  v-if="(allData.length>0)" :style="!permissions.find(e => e.permission_name == 'View Options') ? 'filter: blur(4px); pointer-events: none;' : ''" >
                    <div class="card-body">
                        <table class="table table-hover">
                            <thead class="thead-light">
                                <tr>
                                    <th>#</th>
                                    <th>Type</th>
                                    <!-- <th>Price</th> -->
                                    <th>Category</th>
                                    <th>Sub-Category</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody v-if="allData.length>0">
                                <tr v-for="(data,key) in allData" :key="key">
                                    <!-- <pre>{{ data }}</pre> -->
                                    <td>
                                        <a href="#" class="font-weight-bold">
                                            {{key+1}}
                                        </a>
                                    </td>
                                    <td><span class="font-weight-normal">{{data.name}}</span></td>
                                    <!-- <td><span class="font-weight-normal">{{data.price}}</span></td> -->
                                    <td><span class="font-weight-normal">{{ data.cat_id && category_list.find(e => e.id == data.cat_id) ? category_list.find(e => e.id == data.cat_id).category_name : 'N/A' }}</span></td>
                                    <td><span class="font-weight-normal">{{ data.sub_cat_id && sub_category_list.find(e => e.id == data.sub_cat_id) ? sub_category_list.find(e => e.id == data.sub_cat_id).sub_category_name : 'N/A' }}</span></td>
                                    <td>
                                        <span class="font-weight-bold">
                                            <button :disabled="!permissions.find(e => e.permission_name == 'Active/Inactive Option')" class="btn btn-danger btn-xs" href="#" @click="updateStatus(data, 1)" v-if="data.status==0"> Inactive</button>
                                            <button :disabled="!permissions.find(e => e.permission_name == 'Active/Inactive Option')" class="btn btn-success btn-xs" href="#" @click="updateStatus(data, 0)" v-if="data.status==1"> Active</button>
                                        </span>
                                    </td>
                                    <td>
                                        <div class="btn-group">
                                            <!-- <router-link class="btn btn-success btn-xs" :to="{name : 'index', params: { page: 'OptionsValues', action: 'view', id: data.id,  code: data.id }}"><span class="fa fa-eye mr-2"></span>Options Values</router-link> -->
                                            <router-link class="btn btn-primary btn-xs" :to="{name : 'index', params: { page: page, action: 'edit', id: data.id }}"><span class="fa fa-edit mr-2"></span>Edit</router-link>
                                            <!-- <a @click="remove(data.id)" class="btn btn-danger btn-xs" href="#"><span class="fa fa-trash-alt mr-2"></span>Remove</a> -->
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td class="text-center" colspan="5">No record found</td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- <div class="card-footer px-3 border-0 d-flex align-items-center justify-content-between">
                            <nav aria-label="Page navigation example">
                                <ul class="pagination mb-0">
                                    <template v-for="(paginate,key) in allData">
                                        <li :key="key" class="page-item" :class="{'active': paginate.active}" v-if="paginate.url">
                                            <a class="page-link" @click="viewAllUrl=paginate.url;allDatas(false)" v-html="paginate.label"></a>
                                        </li>
                                    </template>
                                </ul>
                            </nav>
                            <div class="font-weight-bold small">Page <b>{{allData.current_page}}</b> of <b>{{allData.last_page}}</b> page Total record <b>{{allData.total}}</b></div>
                        </div> -->
                        
                    </div>
                </div>
                <div class="card-body text-center" v-else>
                    <div v-if="loading">
                        loading...
                    </div>
                    <div v-else>
                        <div>
                            <h3>Add and manage your {{page}}</h3>
                            <p>This is where you’ll add {{page}} and manage theme. You can also improve your website by adding.</p>
                            <router-link :to="{name : 'index', params: { page: page, action: 'add' }}" class="btn btn-primary" type="button">Add {{page}}</router-link>
                            <br><br><br>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="row">
                <div style="position: absolute; margin-top: 200px; z-index: 1; width: max-content; left: 50%;" v-if="action != 'edit' && !permissions.find(e => e.permission_name == 'Create Option')">
                    <span style="color: red;"><i class="mr-2 fa fa-eye-slash"></i>You dont have the creating permission.</span>
                </div>
                <div style="position: absolute; margin-top: 200px; z-index: 1; width: max-content; left: 50%;" v-else-if="action == 'edit' && !permissions.find(e => e.permission_name == 'Edit Opiton')">
                    <span style="color: red;"><i class="mr-2 fa fa-eye-slash"></i>You dont have the updating permission.</span>
                </div>
                <div :style="!permissions.find(e => e.permission_name == 'Create Option') || (action == 'edit' && !permissions.find(e => e.permission_name == 'Edit Categories')) ? 'filter: blur(4px); pointer-events: none;' : ''" >
                    <div class="col-12 col-xl-8">
                        <div class="card card-body bg-white border-light shadow-sm mb-4">
                            <h2 class="h5 mb-4">General information</h2>
                            <div v-if="loading">
                                <i class="fa fa-spinner" aria-hidden="true"></i>  loading...
                            </div>
                            <div class="row" v-else v-for="(item,index) in cat_sub_cat_list" :key="index">
                                <div :class="action == 'add' ? 'col-md-5 mb-3' : 'col-md-6 mb-3'">
                                    <label for="birthday">Select A Category</label>
                                    <MssSelect type="select" :disabled="action == 'edit'" @input="fetchSubCategory(index)" v-model="item.selected_category" :options="category_list" :reduce="options => options.id" label="category_name" placeholder="Category"></MssSelect>
                                </div>
                                <div :class="action == 'add' ? 'col-md-5 mb-3' : 'col-md-6 mb-3'">
                                    <label for="birthday">Select A Sub-Category</label>
                                    <MssSelect type="select" :disabled="action == 'edit'" v-model="item.selected_sub_category" :options="item.sub_cat_list" :reduce="options => options.id" label="sub_category_name" placeholder="Sub-Category"></MssSelect>
                                </div>
                                <div class="col-md-2 mb-3" style="text-align: center;" v-if="action == 'add'">
                                    <label for="birthday">Action</label>
                                    <div>
                                        <button class="btn btn-outline-primary mr-1" style="padding: 5px 10px;" @click="addNewCategory"><i class="fa fa-plus"></i></button>
                                        <button class="btn btn-outline-primary" style="padding: 5px 10px;" v-if="index > 0" @click="removeCategory"><i class="fa fa-minus"></i></button>
                                    </div>
                                </div>
                                <div class="col-md-12 mb-3" style="color: red; text-align: center;" v-if="!item.selected_category && !item.selected_sub_category"><span class="red-color">*</span>Please select atleast one category or sub-category.</div>
                            </div>
                            <div class="row">
                                <div :class="action == 'edit' ? 'col-md-6 mb-3' : 'col-md-12 mb-3'">
                                    
                                    <MssInput v-model="form.name" placeholder="Enter Option Name" required></MssInput>
                                </div>
                                <div class="col-md-6 mb-3" v-if="action == 'edit'">
                                    <MssInput v-model="form.id" disabled placeholder="Option Id"></MssInput>
                                </div>
                                <!-- <div class="col-md-12 mb-3">
                                    <MssInput v-model="form.price" placeholder="Price"></MssInput>
                                </div> -->
                                <!-- <div class="row align-items-center">
                                    <div class="col-md-12 mb-3">
                                        <label for="birthday">Description <span class="red-color">*</span></label>
                                        <MssInput type="textarea" v-model="form.description"></MssInput>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-4 sidebar-stricky">
                        <div class="card card-body bg-white border-light shadow-sm mb-4">
                            <h2 class="h5 mb-4">Visibility</h2>
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <MssInput type="switch" v-model="form.status" placeholder="Visible this to all"></MssInput>
                                </div>
                                <!-- <div class="col-md-12 mb-3">
                                    <MssInput type="switch" v-model="form.is_featured" placeholder="Is Feature"></MssInput>
                                </div> -->
                                <div class="col-md-12 mb-3">
                                    <div>
                                        <button @click="submit" class="btn btn-info btn-block" v-if="action=='add'">Publish</button>
                                        <button @click="submit" class="btn btn-success btn-block" v-else>Update</button>
                                    </div>
                                </div>
                            </div>
                        </div>
        
                        <!-- <div class="card card-body bg-white border-light shadow-sm mb-4">
                                <div class="row">
                                    <h2 class="col-md-8 h5 mb-4">SEO information</h2>
                                    <div class="col-md-4 text-right">
                                        <button @click="defaultSEO=false;editSEO = editSEO ? false : true" class="btn btn-info btn-xs"><span class="far fa-edit mr-2"></span>Edit</button>
                                    </div>
                                </div>
                                <div class="row" v-if="editSEO">
                                    <div class="col-md-6 mb-3">
                                        <MssInput v-model="form.meta_title" placeholder="SEO title of this page"></MssInput>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <MssInput v-model="form.meta_keywords" placeholder="keywords for this page"></MssInput>
                                    </div>
                                    <div class="col-md-12 mb-3">
                                        <MssInput type="textarea" v-model="form.meta_description" placeholder="Seo Description max 150 char"></MssInput>
                                    </div>
                                </div>
                                <div v-else class="row align-items-center">
                                    <h3>{{form.meta_title}}</h3>
                                    <a href="javascript:;">{{URL_ROOT}}category/{{form.linkname}}</a>
                                    <p>{{limitedword(striphtml(form.meta_description),150)}}</p>
        
                                </div>
                            </div> -->
                    </div>
                </div>
            </div>
        </template>
    </div>
    </template>
    
    <script>
    import {
        VueEditor
    } from "vue2-editor";
    import $ from 'jquery'
    import axios from 'axios'
    export default {
        components: {
            VueEditor
        },
        props: [
            "page", "action", "id", "type"
        ],
        data() {
            return {
                selectedCategory: null,
                isEditor: true,
                loading: false,
                allData: [],
                cat_sub_cat_list: [{
                    sub_cat_list: [],
                    selected_category: null,
                    selected_sub_category: null,
                }],
                selected_files: [],
                form: {
                    id: null,
                    name: '',
                    status: true,
                    // description: '',
                    // price: null,
                    category: null,
                    sub_category: null,
                    type: 'category_save',
                },
                editSEO: false,
                defaultSEO: true,
                pageList: [],
                sub_category_list: [],
                category_list: [],
                fullToolbar: [
                    [{
                        'font': []
                    }],
                    [{
                        'header': [false, 1, 2, 3, 4, 5, 6, ]
                    }],
                    [{
                        'size': ['small', false, 'large', 'huge']
                    }],
                    ['bold', 'italic', 'underline', 'strike'],
                    [{
                        'align': [false, 'justify', 'center', 'right']
                    }],
                    [{
                        'list': 'ordered'
                    }, {
                        'list': 'bullet'
                    }, {
                        'list': 'check'
                    }],
                    [{
                        'indent': '-1'
                    }, {
                        'indent': '+1'
                    }],
                    [{
                        'color': []
                    }, {
                        'background': []
                    }],
                    ['link', 'image', 'video', 'formula'],
                    ['clean'],
                ],
                viewAllUrl: '',
                permissions: null,
            }
        },
        methods: {
            addNewCategory() {
                this.cat_sub_cat_list.push({
                    sub_cat_list: [],
                    selected_category: null,
                    selected_sub_category: null,
                })
            },
            removeCategory() {
                this.cat_sub_cat_list.splice(-1)
                // console.log(this.cat_sub_cat_list);
            },
            updateStatus(data, status) {
                var ev = this
                const updateData = {
                    opt_id: data.id,
                    cat_id: data.cat_id,
                    sub_cat_id: data.sub_cat_id,
                    opt_name: data.name,
                    // opt_desc: data.description,
                    // price: data.price,
                    status: status,
                    type: 'updateOptions'
                }
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    data: updateData
                }).then((response) => {
                    ev.$toasted.global[response.data.status]({
                        message: response.data.msg
                    })
                    ev.newAllDatas()
                })
            },
            update(table, status, id) {
                var param = {
                    id: id,
                    status: status,
                    table: table,
                    type: 'commonStatus'
                }
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'api.php',
                    data: param
                }).then(function (response) {
                    var data = response.data;
                    // console.log('status', data)
                })
            },
            async addInit() {
                // this.getUnderof();
                await this.fetchCategory()
                await this.fetchSubCategory()
                this.reset()
            },
            editInit() {
                this.fetchCategory()
                // this.fetchSubCategory()
                this.getDetail();
                // this.getUnderof();
            },
            viewInit() {
                this.fetchCategory()
                this.fetchSubCategory()
                this.newAllDatas()
            },
            reset() {
                this.form = {
                    id: null,
                    name: '',
                    status: true,
                    // description: '',
                    category: null,
                    // price: null,
                    sub_category: null,
                    type: 'category_save',
                };
                this.cat_sub_cat_list = [
                    {
                        sub_cat_list: [],
                        selected_category: null,
                        selected_sub_category: null,
                    }
                ]
                this.selected_category = null
                this.selected_sub_category = null
            },
            async fetchSubCategory(index = null) {
                const response = await axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    data: index != null ? {
                        type: 'fetchSubCategory',
                        status: true,
                        cat_id: this.cat_sub_cat_list[index].selected_category
                    } :{
                        type: 'fetchSubCategory',
                        // status: true
                    }
                })  
                if (index != null) {
                    this.cat_sub_cat_list[index].sub_cat_list = response.data.data
                    this.loading = false
                } else {
                    this.sub_category_list = response.data.data
                }
            },
            async fetchCategory() {
                const response = await axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    data: {
                        type: 'fetchAllCategories',
                        // status: true
                    }
                })
                this.category_list = response.data.data
            },
            getUnderof() {
                var pList = [];
                pList.push({
                    label: 'Parent',
                    code: 0
                })
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'api.php?type=getCategory',
                }).then(function (response) {
                    var data = response.data;
                    $.each(data, function (key, param) {
                        pList.push({
                            label: param.heading,
                            code: param.id
                        })
                    })
                })
    
            },
            upload_file() {
                // var ev = this;
                this.file = this.$refs.file.files[0];
    
                // let formData = new FormData();
                // console.log(formData);
                // this.save_userimage();
    
            },
            // save_userimage: function () {
            //     var ev = this;
            //     this.file = this.$refs.file.files[0];
    
            //     let formData = new FormData();
    
            //     formData.append('photo', this.file);
            //     formData.append('id', this.id);
    
            //     if (this.file == undefined) {
            //         ev.$swal({
            //             message: "please upload image"
            //         });
            //     } else {
            //      if(this.action=='edit'){
            //         axios.post(this.$root.URL_ROOT + 'api.php?type=category_edit', formData, {
            //                 headers: {
            //                     'Content-Type': 'multipart/form-data'
            //                 }
            //             })
            //             .then(function (response) {
            //                 var data = response.data;
            //                 //console.log(data);
            //                 if (data.status == "success") {
            //                     ev.$swal({
            //                         title: data.msg,
            //                     });
            //                     // ev.getUserDetail();
    
            //                 } else {
            //                     ev.$swal({
            //                         title: data.msg,
            //         // text:data.msg
            //                     });
            //                 }
            //             })
            //     }
            //     }
    
            // },
            getDetail() {
                this.loading = true
                var ev = this
                var param = {
                    opt_id: this.id
                }
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php?type=fetchOptions',
                    data: param
                }).then(function (response) {
                    var data = response.data;
                    ev.form = data.data[0]
                    ev.cat_sub_cat_list[0] = {
                        selected_category: data.data[0].cat_id,
                        selected_sub_category: data.data[0].sub_cat_id,
                        sub_cat_list: []
                    }
                    // ev.form.category = data.data[0].cat_id
                    // ev.form.sub_category = data.data[0].sub_cat_id
                    // ev.selected_category = data.data[0].cat_id
                    // ev.selected_sub_category = data.data[0].sub_cat_id
                }).then (() => {
                    ev.fetchSubCategory(0)
                })
            },
            async newAllDatas(id = null) {
                const params = id ? {
                    id,
                    type: 'fetchOptions'
                } : {
                    type: 'fetchOptions'
                }
                const response = await axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    params
                })
                this.allData = response.data.data
            },
            allDatas() {
                this.newAllDatas()
                return
                var ev = this
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'api.php?type=getCategory',
                    data: {
                        page_no: 2,
                        limit: 5
                    }
                }).then(function (response) {
                    var data = response.data;
                    console.log(data);
                    ev.allData = data
                })
            },
            async save_data(data) {
                const response = await axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    data: data
                })
                return response.data
            },
            async submit() {
                var ev = this
                // this.file = this.$refs.file.files[0];
                // this.file = this.$refs.front_image.files[0];
                // this.banner = this.$refs.banner.files[0];
                // if (!this.form.category && !this.form.sub_category) {
                //     this.$toasted.global.error({
                //         message: 'Please select atleast one category or subcategory.'
                //     })
                // } else if (this.form.opt_type === '') {
                //     this.$toasted.global.error({
                //         message: 'Please enter a option name.'
                //     })
                // }  else {
                    let status = ''
    
                    if (ev.form.status == true) {
                        status = 1
                    } else {
                        status = 0
                    }
                    // let formData = new FormData();
                    // if (this.action == 'edit') {
                    //     formData.append('cat_id', this.id);
                    //     // this.form.type = 'category_edit';
                    // }
                    // formData.append('image_collection', this.$refs.image_collection.files);
                    // for (var i = 0; i < this.$refs.image_collection.files.length; i++) {
                    //     let file = this.$refs.image_collection.files[i];
                    //     formData.append('image_collection[' + i + ']', file);
                    // }
                    // formData.append('lorder', this.form.lorder);
                    // formData.append('banner', this.banner);
                    // formData.append('photo', this.file);
                    // formData.append('cat_name', this.form.category_name);
                    // formData.append('cat_desc', this.form.category_description);
                    // formData.append('cat_status', status);
                    // formData.append('cat_price', this.form.price);
                    // formData.append('is_featured', this.form.is_featured);
                    // formData.append('type', this.form.type);
                    let checked = true
                    const mapped_data = this.cat_sub_cat_list.map( async e => {
                        if (!e.selected_category &&  !e.selected_sub_category) {
                            this.$toasted.global.error({
                                message: 'Please select atleast one category or subcategory.'
                            })
                            checked = false
                        }
                        if (!this.form.name || this.form.name === '') {
                            this.$toasted.global.error({
                                message: 'Please enter a option name.'
                            })
                            checked = false
                        }
                        if (checked) {
                            const data = this.action == 'edit' ? {
                                opt_id: this.form.id,
                                cat_id: e.selected_category,
                                sub_cat_id: e.selected_sub_category,
                                opt_name: this.form.name,
                                // opt_desc: this.form.description,
                                // price: this.form.price,
                                status: status,
                                type: 'updateOptions'
                            } : {
                                cat_id: e.selected_category,
                                sub_cat_id: e.selected_sub_category,
                                opt_name: this.form.name,
                                // opt_desc: this.form.description,
                                // price: this.form.price,
                                status: status,
                                type: 'createOptions'
                            }
    
                            const response = await this.save_data(data)
                            return response.status
                        }
                    })
                    if (!checked) return
                    const response_data = await Promise.all(mapped_data)
                    if (response_data.filter(e => e == 'success').length == response_data.length) {
                        this.$toasted.global.success({
                            message: response_data.length > 1 ? 'Options added successfully.' : 'Option added successfully.'
                        })
                    } else {
                        this.$toasted.global.error({
                            message: 'Something is wrong.'
                        })
                    }
                    console.log(ev.page);
                    ev.$router.push({
                        name: 'index',
                        params: {
                            page: ev.page,
                            // action: 'view',
                            // id: response.data.id
                        }
                    })
                    // window.location.reload()
                    // axios({
                    //     method: 'POST',
                    //     url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    //     data: data
                    // }).then(function (response) {
                    //     var data = response.data;
                    //     if (data.status == "success") {
                    //         ev.$swal({
                    //             toast: true,
                    //             position: 'top-end',
                    //             timer: 5000,
                    //             icon: 'success',
                    //             timerProgressBar: true,
                    //             title: 'Action perform successfully'
                    //         })
                    //         ev.$router.push({
                    //             name: 'index',
                    //             params: {
                    //                 page: ev.page,
                    //                 // action: 'view',
                    //                 // id: response.data.id
                    //             }
                    //         })
                    //         window.location.reload()
                    //     } else {
    
                    //         setTimeout(() => ev.$swal(data.msg), 1000);
    
                    //     }
                    // })
                // }
            },
            remove(id) {
                var self = this;
                var param = {
                    id: id,
                    table: 'mss_category',
                    type: 'commonDelete'
                }
                this.$swal({
                    title: "Delete this ?",
                    text: "Are you sure? You won't be able to revert this!",
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonColor: "#f00",
                    confirmButtonText: "Yes, Delete it!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios({
                            method: 'POST',
                            url: this.$root.URL_ROOT + 'api.php',
                            data: param
                        }).then(function (response) {
                            var data = response.data;
                            // console.log('commonDelete', data)
                            self.allDatas()
                        })
                    }
                })
            }
        },
        mounted() {
            if (localStorage.getItem('permissions')) {
                const permissionsLS = localStorage.getItem('permissions')
                const permission = JSON.parse(permissionsLS)
                this.permissions = permission.filter(e => e.section == 'OPTIONS' && e.has_permission == true)
            }
            if (this.action == "view") {
                this.viewInit()
            } else if (this.action == "edit" && this.id > 0) {
                this.editInit()
            } else if (this.action == "add") {
                this.addInit();
            } 
        },
        watch: {
            'action': function (val) {
                if (val == "view") {
                    this.viewInit()
                } else if (val == "edit" && this.id > 0) {
                    this.editInit()
                } else if (val == "add") {
                    this.addInit();
                }
            },
            'form.linkname': function (val) {
                var text = val.replace(' ', "")
                this.form.linkname = text
            },
            'loading': function (val) {
                if (val) {
                    this.$swal.showLoading();
                } else {
                    this.$swal.close()
                }
            },
            'q': function (newVal, oldVal) {
                if (newVal == '') {
                    this.viewAllUrl = this.URL_ROOT + 'admin/' + this.page + '/all';
                } else if (newVal != oldVal) {
                    this.viewAllUrl = this.URL_ROOT + 'admin/' + this.page + '/all/' + newVal;
                }
                this.allDatas(false);
            },
            // selected_category(val) {
            //     this.form.category = val
            //     this.fetchSubCategory()
            // },
            // selected_sub_category(val) {
            //     this.form.sub_category = val
            // }
        }
    }
    </script>
    
    <style scoped>
    @import "~vue2-editor/dist/vue2-editor.css";
    </style>
    